import React from 'react'
import { Button, Table } from 'antd'
import { sqlToJsDate } from '../../../../../utils/date.helper'
import { CheckCircleOutlined, CloseCircleOutlined, ExportOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { buildClarityLinkToRecord } from '../../../../../utils/link.helper'
import { useThemeColors } from '../../../../../hooks/useThemeColors'

const FeedbackFromStudentsTable = ({ isWaitingForFeedbackFromStudents }) => {
    const assignmentStudentsFeedback = useSelector(state => state.assignments.assignmentStudentsFeedback)
    const colors = useThemeColors()

    const columns = [
        {
            title: 'Student ID',
            key: 'studentId',
            dataIndex: 'studentId',
            width: '15%',
        },
        {
            title: 'Liked',
            key: 'liked',
            dataIndex: 'liked',
            width: '8%',
            render: liked =>
                liked ? (
                    <CheckCircleOutlined style={{ color: colors.success, fontSize: '1.5rem' }} />
                ) : (
                    <CloseCircleOutlined style={{ color: colors.error, fontSize: '1.5rem' }} />
                ),
        },
        {
            title: 'Feedback',
            key: 'feedback',
            dataIndex: 'feedback',
            width: '54%',
        },
        {
            title: 'Created At',
            key: 'createdAt',
            dataIndex: 'createdAt',
            width: '15%',
            render: createdAt => sqlToJsDate(createdAt),
        },
        {
            title: 'Action',
            key: 'action',
            width: '8%',
            render: (_, record) => (
                <>
                    <a href={buildClarityLinkToRecord(record.studentId)} target='_blank' rel='noreferrer'>
                        <Button
                            shape='circle'
                            type='text'
                            aria-label='Find user in Clarity'
                            title='Find User in Clarity'
                            onClick={() => {}}
                        >
                            <ExportOutlined className='primary-color' />
                        </Button>
                    </a>
                </>
            ),
        },
    ]

    const unitTestsTableData = assignmentStudentsFeedback.map(assignmentStudentFeedback => ({
        key: assignmentStudentFeedback.id,
        studentId: assignmentStudentFeedback.user_id,
        liked: assignmentStudentFeedback.liked,
        feedback: assignmentStudentFeedback.feedback || '-',
        createdAt: assignmentStudentFeedback.created_at,
        olderFeedbacks: assignmentStudentFeedback.older_feedbacks,
    }))

    const expandedRowRender = record => {
        const nestedColumns = [
            {
                title: 'Student ID',
                key: 'studentId',
                dataIndex: 'studentId',
                width: '15%',
                render: () => record.studentId,
            },
            {
                title: 'Liked',
                key: 'liked',
                dataIndex: 'liked',
                width: '8%',
                render: liked =>
                    liked ? (
                        <CheckCircleOutlined style={{ color: colors.success, fontSize: '1.5rem' }} />
                    ) : (
                        <CloseCircleOutlined style={{ color: colors.error, fontSize: '1.5rem' }} />
                    ),
            },
            {
                title: 'Feedback',
                key: 'feedback',
                dataIndex: 'feedback',
                width: '54%',
            },
            {
                title: 'Created At',
                key: 'createdAt',
                dataIndex: 'createdAt',
                width: '15%',
                render: createdAt => sqlToJsDate(createdAt),
            },
            {
                title: 'Action',
                key: 'action',
                width: '8%',
                render: () => <Button shape='circle' type='text' aria-label='Find user in Clarity' title='Find user in Clarity' onClick={() => {}}><ExportOutlined className='primary-color' /></Button>
            },
        ]
        const nestedData = record.olderFeedbacks.map(olderFeedback => ({
            key: olderFeedback.id,
            studentId: olderFeedback.user_id,
            liked: olderFeedback.liked,
            feedback: olderFeedback.feedback || '-',
            createdAt: olderFeedback.created_at,
        }))

        return <Table columns={nestedColumns} dataSource={nestedData} pagination={false} />
    }

    return (
        <Table
            expandable={{
                expandedRowRender,
                rowExpandable: record => record.olderFeedbacks.length,
            }}
            columns={columns}
            dataSource={unitTestsTableData}
            pagination={false}
            loading={isWaitingForFeedbackFromStudents}
        />
    )
}

export default FeedbackFromStudentsTable
